import types from './types';
import deleteIn from 'components/connectedForm/utils/deleteIn';
import getIn from 'components/connectedForm/utils/getIn';
import setIn from 'components/connectedForm/utils/setIn';

const initialState = {
  menu: {},
  folders: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SERVICE_DATA_TO_MENU:
      return {
        ...state,
        menu: {
          ...state.menu,
          [action.data.screenReference]: action.data,
        },
      };

    case types.SERVICE_DATA_TO_FOLDER:
      return {
        ...state,
        folders: {
          ...state.folders,
          [action.data.id]: action.data,
        },
      };

    case types.SERVICE_DATA_FROM_MENU:
      let sortOrder = getIn(state, ['menu', action.screenReference, 'sortOrder']);
      state = deleteIn(state, ['menu', action.screenReference]);
      let newState = Object.assign({}, state);
      let menuKeys = Object.keys(newState.menu);
      let value;
      for (let i = 0; i < menuKeys.length; i++) {
        if (newState.menu[menuKeys[i]] > sortOrder) {
          value = getIn(state, ['menu', menuKeys[i], 'sortOrder']);
          state = setIn(state, ['menu', menuKeys[i], 'sortOrder'], value - 1);
        }
      }
      let foldersKeys = Object.keys(newState.folders);
      for (let j = 0; j < foldersKeys.length; j++) {
        if (newState.folders[foldersKeys[j]] > sortOrder) {
          value = getIn(state, ['folders', foldersKeys[j], 'sortOrder']);
          state = setIn(state, ['folders', foldersKeys[j], 'sortOrder'], value - 1);
        }
      }
      return state;

    case types.SERVICE_LIST_TO_MENU:
      let newMenuState = {
        ...state,
        menu: {
          ...state.menu,
        },
      };
      if (action.data) {
        action.data.screens.forEach((option) => {
          newMenuState = {
            ...newMenuState,
            menu: {
              ...newMenuState.menu,
              [option.screenReference]: option,
            },
          };
        });
      }
      return newMenuState;

    case types.SERVICE_LIST_TO_FOLDER:
      let newFolderState = {
        ...state,
        folders: {
          ...state.folders,
        },
      };
      action.data.folders.forEach((option) => {
        newFolderState = {
          ...newFolderState,
          folders: {
            ...newFolderState.folders,
            [option.id]: option,
          },
        };
      });
      return newFolderState;

    case types.SERVICE_BULK_TO_MENU:
      let newBulkState = {
        menu: {},
        folders: {},
      };
      action.data.screens.forEach((option) => {
        newBulkState = {
          ...newBulkState,
          menu: {
            ...newBulkState.menu,
            [option.screenReference]: option,
          },
        };
      });
      action.data.folders.forEach((option) => {
        newBulkState = {
          ...newBulkState,
          folders: {
            ...newBulkState.folders,
            [option.id]: option,
          },
        };
      });
      return newBulkState;

    case types.CHANGE_FOLDER_NAME:
      return {
        ...state,
        folders: {
          ...state.folders,
          [action.requestBody.id]: {
            ...state.folders[action.requestBody.id],
            name: action.requestBody.name,
          },
        },
      };

    case types.DELETE_MENU_ITEM:
      if (action.data.__typename === 'Screen') {
        state = deleteIn(state, ['menu', action.data.screenReference]);
      } else {
        state = deleteIn(state, ['folders', action.data.id.toString()]);
      }
      let sortOrderValue = action.data.sortOrder;
      let screenFolder = action.data.folder;

      let newStateObj = Object.assign({}, state);
      let menuHeaders = Object.keys(newStateObj.menu);
      let foldersHeader = Object.keys(newStateObj.folders);
      let sortValue;
      for (let i = 0; i < menuHeaders.length; i++) {
        if (
          newStateObj.menu[menuHeaders[i]].sortOrder > sortOrderValue &&
          screenFolder === newStateObj.menu[menuHeaders[i]].folder
        ) {
          sortValue = getIn(state, ['menu', menuHeaders[i], 'sortOrder']);
          state = setIn(state, ['menu', menuHeaders[i], 'sortOrder'], sortValue - 1);
        }
      }

      for (let j = 0; j < foldersHeader.length; j++) {
        if (newStateObj.folders[foldersHeader[j]].sortOrder > sortOrderValue) {
          sortValue = getIn(state, ['folders', foldersHeader[j], 'sortOrder']);
          state = setIn(state, ['folders', foldersHeader[j], 'sortOrder'], sortValue - 1);
        }
      }

      return state;

    default:
      return state;
  }
}
export default reducer;
